import type { ContentTabViewModel } from '../types/ContentTabViewModel';

/**
 * The creator's default content tab — the one shown at the bare bio index
 * `/<urlCode>` (no tab segment) and highlighted in the strip there.
 *
 * It is the creator's explicitly-marked default (`isDefault`) if any, else the
 * first tab in their configured order. NEVER hardcoded to "store": a creator
 * may hide Store or order My Life / My Feed first, and the strip + the index
 * body must agree on the same default — so both resolve it through here.
 *
 * `undefined` only when every tab is hidden (the visitor strip is empty).
 */
export function defaultContentTab(
  tabs: ContentTabViewModel[],
): ContentTabViewModel | undefined {
  return tabs.find(tab => tab.isDefault) ?? tabs[0];
}
